"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Use this class to create field validation
 */

var BaseEntityFieldValidator =
/** @class */
function () {
  /**
   * Construct validator with required params
   * @param maxLength
   * @param minLength
   * @param regexPattern valid regex pattern
   */
  function BaseEntityFieldValidator(minLength, maxLength, regexPattern) {
    var _this = this;
    /**
     * Validate and return error type, if validation pass the result will be undefined
     * @param value string to be validated
     */


    this.isError = function (value) {
      return !_this.regexPattern.test(value) ? ENTITY_FIELD_VALIDATION_RESULT.PATTERN : value.length > _this.maxLength ? ENTITY_FIELD_VALIDATION_RESULT.MAX_LENGTH : value.length < _this.minLength ? ENTITY_FIELD_VALIDATION_RESULT.MIN_LENGTH : undefined;
    };

    this.maxLength = maxLength;
    this.minLength = minLength;
    this.regexPattern = regexPattern;
  }

  BaseEntityFieldValidator.genericTextInputRegexPattern = /^[\u0E00-\u0E3E\u0E40-\u0E7Fa-zA-Z0-9\u2018\u2019\u201C\u201D\u00AE\u002F\&\(\)\_\+\-\*\'\"\#\@\%\.\<\>\|\s]*$/;
  BaseEntityFieldValidator.genericTextInputENRegexPattern = /^[a-zA-Z0-9\u2018\u2019\u201C\u201D\u00AE\u002F\&\(\)\_\+\-\*\'\"\#\@\%\.\<\>\|\s]*$/;
  return BaseEntityFieldValidator;
}();

exports.BaseEntityFieldValidator = BaseEntityFieldValidator;
var ENTITY_FIELD_VALIDATION_RESULT;

(function (ENTITY_FIELD_VALIDATION_RESULT) {
  ENTITY_FIELD_VALIDATION_RESULT["MAX_LENGTH"] = "MAX_LENGTH";
  ENTITY_FIELD_VALIDATION_RESULT["MIN_LENGTH"] = "MIN_LENGTH";
  ENTITY_FIELD_VALIDATION_RESULT["PATTERN"] = "PATTERN";
})(ENTITY_FIELD_VALIDATION_RESULT = exports.ENTITY_FIELD_VALIDATION_RESULT || (exports.ENTITY_FIELD_VALIDATION_RESULT = {}));